import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  standalone: false,
})
export class ConfigurationComponent {
  @Input() config!: any;
  @Input() disableInput!: boolean;
  @Output() changed: EventEmitter<any> = new EventEmitter<any>();
}
